import React, { ReactElement, useEffect, useState } from 'react';
import { Navbar } from './Components/NavBar/Navbar';
import { Welcome } from './Components/Welcome/Welcome';
import { Assignments } from './Components/Assignments/Assignments';
import { Lectures } from './Components/Lectures/Lectures';
import { Labs } from './Components/Labs and Sections/Labs';
import { CodeAlong } from './Components/CodeAlong/CodeAlong';
import { Hours } from './Components/Hours/Hours';
import { Resources } from './Components/Resources/Resources';
import { SRC } from './Components/SRC/SRC';
import { Staff } from './Components/Staff/Staff';
import './App.scss'

import { handleOnMove, updateLastMousePosition, originPosition } from './MouseEffects';

export interface SectionProps {
    static?: boolean;
}

export enum Page {
  WELCOME, ASSIGNMENTS, LECTURES, LABS, CODEALONG, HOURS, SRC, RESOURCES, STAFF
}

function App() {
  const [page, setPage] = useState(0);

  useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => handleOnMove(e);
    const handleMouseLeave = () => updateLastMousePosition(originPosition);

    window.addEventListener('touchmove', handleTouchMove);
    document.body.addEventListener('mouseleave', handleMouseLeave);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener('touchmove', handleTouchMove);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  function activePage(): ReactElement {
    switch (page) {
      case Page.WELCOME:
        return <Welcome />;
      case Page.ASSIGNMENTS:
        return <Assignments />;
      case Page.LECTURES:
        return <Lectures />;
      case Page.LABS:
        return <Labs />;
      case Page.CODEALONG:
        return <CodeAlong />;
      case Page.HOURS:
        return <Hours />;
      case Page.SRC:
        return <SRC />;
      case Page.RESOURCES:
        return <Resources />;
      case Page.STAFF:
        return <Staff />;
      default:
        return <Welcome />;
    }
  }

  return (
    <div className="app">
      <Navbar setPage={setPage}/>
      {activePage()}
    </div>
  );
}

export default App;

